import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import { makeEntityScaffold } from '@classpass/saga-tools';
import fetch from '../../../universal-fetch';
export var jobs = makeEntityScaffold('SAGA.FETCH_JOBS', function () {
  if (__SERVER__) {
    var getJobs = require('../../../../server/handlers/job-posts').getJobs;

    return getJobs();
  }

  return fetch('/_jobs').then(function (res) {
    return res.json();
  });
});
export var jobById = makeEntityScaffold('SAGA.FETCH_JOB_BY_ID', function (client, id) {
  if (__SERVER__) {
    var getJob = require('../../../../server/handlers/job-posts').getJob;

    return getJob(id);
  }

  return fetch("/_jobs/".concat(id)).then(function (res) {
    return res.json();
  });
}, {
  defaultKey: 1
});
export var postApplication = makeEntityScaffold('SAGA.CREATE_APPLICATION', function (client, payload) {
  var body = new FormData();
  Object.keys(payload).forEach(function (key) {
    if (payload[key]) {
      body.append(key, payload[key]);
    }
  });
  return fetch('/_jobs', {
    method: 'POST',
    body: body
  }).then(function (res) {
    return res.json();
  });
});